import { render, staticRenderFns } from "./TicketPhotos.vue?vue&type=template&id=4a0d882b&"
import script from "./TicketPhotos.vue?vue&type=script&lang=js&"
export * from "./TicketPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0d882b')) {
      api.createRecord('4a0d882b', component.options)
    } else {
      api.reload('4a0d882b', component.options)
    }
    module.hot.accept("./TicketPhotos.vue?vue&type=template&id=4a0d882b&", function () {
      api.rerender('4a0d882b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TicketPhotos.vue"
export default component.exports